import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    paddingTop: 20,
  },
  sectionHeading: {
    paddingTop: 12,
    marginTop: 0,
  },
  profile: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
  },
  profileAvatar: {
    width: 80,
    flexShrink: 0,
  },
  profileInfo: {
    flex: 1,
  },
  viewProfile: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    gap: 12,
  },
  button: {
    flex: 1,
    minHeight: 40,
    paddingHorizontal: 12,
  },
  viewProfileButton: {
    flex: 1,
  },
  buttonText: {
    flexWrap: 'nowrap',
    fontSize: 14,
  },
  optaviaIdContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  optaviaIdValueContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 8,
    flexShrink: 0,
  },
  optaviaIdValue: {
    marginRight: 4,
  },
  copyIcon: {
    fontSize: 16,
  },
  stats: {
    marginTop: 20,
  },
  statItem: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
